import * as urls from '../config'
import axios from 'axios'

export default {
  getGalerias (page, perPage) {
    let service = urls.WP_URL + 'galerias-ordenadas/?per_page=' + perPage + '&page=' + page + '&order=desc'
    return axios.get(service)
    .then(response => {
      return response
    })
    .catch(error => {
      console.log(error)
    })
  },
  getFotos (slug) {
    let service = urls.WP_URL + 'galeria-por-slug/?slug=' + slug + '&_embed'
    return axios.get(service)
    .then(response => {
      return response.data[0]
    })
    .catch(error => {
      console.log(error)
    })
  }
}



// WEBPACK FOOTER //
// ./src/js/api/GaleriaService.js